// removed by extract-text-webpack-plugin
module.exports = {"Loader":"-name__-loca-__1DDwY","load7":"-name__-loca-__2S5ij"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.css
// module id = 159
// module chunks = 0